export default {
  schema: {
    title: 'Screen Name',
    type: 'object',
    required: ['org', 'scope', 'npresp'],
    properties: {
      org: {
        title: 'Name of Organization',
        type: 'string',
        maxLength: 20,
        minLength: 10
      },
      description: {
        title: 'Description',
        type: 'string',
        maxLength: 20000
      },
      number: {
        title: 'Integer',
        type: 'integer',
        default: 0
      },
      double: {
        title: 'Double',
        type: 'number'
      },
      percent: {
        title: 'Percent',
        type: 'number',
        minimum: 0,
        maximum: 100
      },
      currency: {
        title: 'Currency',
        type: 'number'
      },
      profacad: {
        title: 'Academic or Professional?',
        type: 'string',
        default: 'Academic',
        enum: ['Academic', 'Professional'],
        enumNames: ['Academic', 'Professional']
      },
      sacsxfer: {
        type: 'boolean',
        title: 'Is this transferable?'
      },
      scope: {
        title: 'Scope of Organization',
        type: 'string',
        enum: ['Local', 'State', 'Regional', 'National', 'International'],
        enumNames: ['Local', 'State', 'Regional', 'National', 'International']
      },
      npresp: {
        title: 'Normal Professional Responsibility',
        type: 'array',
        uniqueItems: true,
        items: {
          type: 'string',
          enum: ['Administration', 'Doctoral Level Teaching/Mentoring', 'Executive Education', 'Graduate Teaching', "Master's Level Teaching", 'Non-Credit Teaching', 'Research', 'Undergraduate Teaching', 'Other Service and Outreach Responsibilities'],
          enumNames: ['Administration', 'Doctoral Level Teach+ing/Mentoring', 'Executive Education', 'Graduate Teaching', "Master's Level Teaching", 'Non-Credit Teaching', 'Research', 'Undergraduate Teaching', 'Other Service and Outreach Responsibilities']
        }
      }
    }
  },
  uiSchema: {
    org: {
      'ui:widget': 'text',
      'ui:help': 'Some help text',
      'ui:title': {
        text: 'Alternate Title',
        escape: false
      }
    },
    description: {
      'ui:widget': 'richtext'
    },
    number: {
      'ui:widget': 'text'
    },
    double: {
      'ui:widget': 'text'
    },
    percent: {
      'ui:widget': 'text',
      'ui:options': {
        after: '%'
      }
    },
    currency: {
      'ui:widget': 'text',
      'ui:options': {
        before: '$',
        currency: 'USD'
      }
    },
    sacsxfer: {
      'ui:widget': 'checkbox'
    },
    profacad: {
      'ui:widget': 'select'
    },
    scope: {
      'ui:widget': 'radio'
    },
    npresp: {
      'ui:widget': 'checkboxes'
    },
    'dm:layout': [{
      type: 'field',
      id: 'org'
    }, {
      type: 'text',
      escape: false,
      text: 'Enter <b>some</b> text below',
      id: 'text1'
    }, {
      type: 'field',
      id: 'description'
    }, {
      type: 'field',
      id: 'number'
    }, {
      type: 'field',
      id: 'sacsxfer'
    }, {
      type: 'field',
      id: 'percent'
    }, {
      type: 'field',
      id: 'currency'
    }, {
      type: 'field',
      id: 'profacad'
    }, {
      type: 'field',
      id: 'scope'
    }, {
      type: 'text',
      escape: true,
      text: 'Check all that apply',
      id: 'text2'
    }, {
      type: 'field',
      id: 'npresp'
    }]
  },
  formData: {
    questionBoolean: false
  }
};